module.exports = __webpack_public_path__ + "img/user-icon.73f317e3.jpg";